module.exports = __webpack_public_path__ + "img/serres-demers.790be812.png";